import { site } from 'lib/src/shared/enums/site';
import { OrganisationTypes } from 'lib/src/types/shared/Organisations';
import { Submission } from './Assessments';

export interface User {
    id: number;
    firstName: string;
    lastName: string;
    email: string;
    roles: number[];
    site: site;
    organisationType: OrganisationTypes;
    organisationSize: number;
    hasMfa: boolean;
    mfaEnabledOn: string | null;
    mfaSecret: string | null;
    pendingMfaSecret: string | null;
}

export interface UserPost {
    firstName: string;
    lastName: string;
    email: string;
}

export enum UserRoles {
    SuperAdmin = 5,
    Admin = 10,
    User = 20,
    Admins = 30,
    ChallengeGroups = 50,
    ChallengeTags = 60,
    Users = 90,
    ContactUsMessages = 100,
    Assessor = 110,
    ChallengeHolder = 120,
    ChallengeView = 130,
    Calendar = 140,
}

export interface FullUser {
    user: User;
    challengeApplications: Submission[];
}

export const userRoleValues: Record<number, string> = {
    [UserRoles.SuperAdmin]: 'Super Admin',
    [UserRoles.Admin]: 'Admin',
    [UserRoles.User]: 'User',
    [UserRoles.Admins]: 'Admins',
    [UserRoles.ChallengeGroups]: 'Challenge Groups',
    [UserRoles.ChallengeTags]: 'Challenge Tags',
    [UserRoles.Users]: 'Users',
    [UserRoles.ContactUsMessages]: 'Contact Us Messages',
    [UserRoles.Assessor]: 'Assessor',
    [UserRoles.ChallengeHolder]: 'Challenges Holder',
    [UserRoles.ChallengeView]: 'Challenge View',
    [UserRoles.Calendar]: 'Calendar',
};

export interface ChallengeViewerOption {
    id: number;
    firstName: string;
    lastName: string;
    userCurrentlyHoldsRole: boolean;
    site: number;
}

export interface ChallengeCalendarAdminOption {
    firstName: string;
    lastName: string;
    id: number;
}
